import { transform } from "../transformers/QuoteActiveViewDataTransformer";
import { type QuoteCartViewDTO } from "~/feature/cart/cart/dto/QuoteCartViewDTO";
import { type TransformedCartData } from "~/feature/cart/cart/transformers/CartViewDataTransformer";
import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/quote/view");

export function getData(): Promise<TransformedCartData> {
  return fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  })
    .then((response) => response.json() as Promise<QuoteCartViewDTO>)
    .then(transform);
}
